/**
 * UI8 - Scroller (animted scrolltop)
 * @author Matt Goucher <matt@mattgoucher.com>
 */
angular.module("UI8.directives").directive("ui8ToggleClass", [
  function () {
    var $doc = $(document),
      elements = {};

    // Registry of all body-targeted toggle classes — used for global Escape handling
    var bodyClasses = [];
    var escapeRegistered = false;

    function registerEscapeHandler() {
      if (escapeRegistered) return;
      escapeRegistered = true;
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape" && e.keyCode !== 27) return;
        var $body = $("body");
        bodyClasses.forEach(function (cls) { $body.removeClass(cls); });
        document.documentElement.style.setProperty("--scrollbar-width", "0px");
        $body.trigger("show-video", [false]);
      });
    }

    function link(scope, elem, attrs) {
      scope.$on("$destroy", function () {
        elem.off("click");
      });

      // Register this class for Escape handling (body-targeted elements only)
      var targetEl = attrs.element || "body";
      if (targetEl === "body" && bodyClasses.indexOf(attrs.ui8ToggleClass) === -1) {
        bodyClasses.push(attrs.ui8ToggleClass);
        registerEscapeHandler();
      }

      elem.on("click", function (e) {
        if (!attrs.allowDefault) e.preventDefault();

        if (!attrs.element) attrs.element = "body";

        if (/modal/.test(attrs.ui8ToggleClass)) {
          $doc.find("body").trigger("open-modal", [attrs.ui8ToggleClass]);
        }

        var _isModalToggle = /modal/.test(attrs.ui8ToggleClass) && attrs.element === "body";
        var _isOpening = _isModalToggle && !$doc.find("body").hasClass(attrs.ui8ToggleClass);

        if (_isOpening) {
          var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
          document.documentElement.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
        }

        if ($(this).data("action") && window.gtag) {
          window.gtag("event", $(this).data("action"), {
            event_category: $(this).data("category") || undefined,
            event_label: $(this).data("label") || undefined,
          });
        }

        if (elements[attrs.element]) {
          elements[attrs.element].toggleClass(attrs.ui8ToggleClass);
        } else {
          elements[attrs.element] = angular
            .element(attrs.element)
            .toggleClass(attrs.ui8ToggleClass);
        }

        // Trigger the respective class name
        $doc.trigger(
          attrs.ui8ToggleClass,
          elements[attrs.element].hasClass(attrs.ui8ToggleClass)
        );

        if (_isModalToggle && !_isOpening) {
          document.documentElement.style.setProperty("--scrollbar-width", "0px");
        }
      });
    }

    return {
      link: link,
      restrict: "A",
    };
  },
]);
